/* eslint-disable react-hooks/exhaustive-deps */
/*
 * Author M. Atoar Rahman
 * Title: D1 Form: Medicines Requisition for Facility
 * Description: Master Setup of D1 Form: Medicines Requisition for Facility Form: Create and Update
 * Date: 15/03/2022
 */
/* prettier-ignore */
import { isEmpty } from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Col, Form, Row, Tab, Tabs } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { Controller, useForm } from 'react-hook-form';
import CommonApiService from '../../../services/CommonApiService';
import SweetAlertService from '../../../services/SweetAlertService';
import { useD1Form } from './ContextAPI';
import RequisitionTable from './RequisitionTable';
import { checkMonthValidation_requisition } from '../../../Utils';

export default function FormInfo({ editData = null, d1Forms }) {
    // Dependancy
    const { drugCategory, getDrugCategory } = CommonApiService();
    const { submitConfirmSwal } = SweetAlertService();
    const [errMsg, setErrMsg] = useState('');
    const { addD1Form, editD1Form, requisitionList, setShow } = useD1Form();

    // Local State
    const [page, setPage] = useState(0);
    const [pageLength, setPageLength] = useState(0);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);

    useEffect(() => {
        if (selectedMonth && selectedYear) {
            const checkMonth = checkMonthValidation_requisition(
                d1Forms,
                selectedMonth,
                selectedYear
            );
            if (!checkMonth) {
                setErrMsg('This month is already taken');
            } else {
                setErrMsg('');
            }
        }
    }, [selectedMonth, selectedYear, d1Forms]);

    const {
        register,
        formState: { errors },
        reset,
        handleSubmit,
        control,
        setValue,
    } = useForm({
        mode: 'onTouched',
        criteriaMode: 'firstError',
        reValidateMode: 'onBlur',
        defaultValues: useMemo(
            () => ({
                ...editData,
                month: editData && new Date(editData.month),
                year: editData && new Date(editData.year),
            }),
            [editData]
        ),
    });

    // Reset default values
    useEffect(() => {
        reset({
            ...editData,
            month: editData && new Date(editData.month),
            year: editData && new Date(editData.year),
        });
    }, [editData]);

    // Set default values
    useEffect(() => {
        if (!isEmpty(requisitionList)) {
            setValue('requisition', requisitionList);
        }
    }, [requisitionList]);

    const dataList = useCallback(() => {
        getDrugCategory(); //  Drug Category
    }, []);

    useEffect(() => {
        dataList();
    }, [dataList]);

    useEffect(() => {
        setPageLength(drugCategory?.length);
    }, [drugCategory]);

    const handleClose = () => {
        setShow(false);
    };

    // Form Submit Handelar
    const formSubmitHandler = async (data) => {
        const isConfirmed = await submitConfirmSwal();

        if (!isConfirmed) {
            return;
        }

        setIsSubmitted(true);
        const formData = {
            ...data,
            month: data.month.getMonth() + 1,
            year: data.year.getFullYear(),
        };
        console.log('payload', formData);

        if (editData) {
            editD1Form(formData, editData.id); // Update Data
        } else {
            addD1Form(formData); // Create Data
        }
        reset();
    };

    const tableDataDisplay = useCallback(
        () =>
            drugCategory?.map((item, index) => (
                <Tab key={item.id} eventKey={index} title={item.name}>
                    <RequisitionTable id={item.id} />
                    {/* {item.id} */}
                </Tab>
            )),
        [drugCategory]
    );
    register('requisition', { required: 'Requisition quantity is required!' });

    return (
        <Form>
            <fieldset className="customFieldset p-4 pb-2 mb-3">
                <Row>
                    <Col lg={6}>
                        <Row>
                            <Col lg={6}>
                                <Form.Group className="mb-3" controlId="formGrnStockID">
                                    <Row className="align-items-center">
                                        <Col lg={4}>
                                            <Form.Label>
                                                Month<span className="invalid">*</span>
                                            </Form.Label>
                                        </Col>
                                        <Col lg={8}>
                                            <Controller
                                                control={control}
                                                name="month"
                                                render={({ field }) => (
                                                    <DatePicker
                                                        {...field}
                                                        closeOnScroll
                                                        selected={field.value}
                                                        placeholderText="Select month"
                                                        dateFormat="MMMM"
                                                        showMonthYearPicker
                                                        showFullMonthYearPicker
                                                        onChange={(date) => {
                                                            const month = date.getMonth() + 1;
                                                            setSelectedMonth(month);
                                                            field.onChange(date);
                                                        }}
                                                        className="form-control"
                                                        popperPlacement="top-end"
                                                    />
                                                )}
                                                rules={{
                                                    required: 'Month is required.',
                                                    valueAsDate: true,
                                                }}
                                            />
                                            {/* {errMsg && <span className="invalid">{errMsg}</span>} */}

                                            {/* {errors.month && (
                                                <span className="invalid">
                                                    {errors.month?.message}
                                                </span>
                                            )} */}
                                            {errMsg && <span className="invalid">{errMsg}</span>}
                                        </Col>
                                    </Row>
                                </Form.Group>
                            </Col>
                            <Col lg={6}>
                                <Form.Group className="mb-3" controlId="formGrnStockID">
                                    <Row className="align-items-center">
                                        <Col lg={4}>
                                            <Form.Label>
                                                Year<span className="invalid">*</span>
                                            </Form.Label>
                                        </Col>

                                        <Col lg={8}>
                                            <Controller
                                                control={control}
                                                name="year"
                                                render={({ field }) => (
                                                    <DatePicker
                                                        {...field}
                                                        closeOnScroll
                                                        selected={field.value}
                                                        dateFormat="yyyy"
                                                        showYearPicker
                                                        placeholderText="Select year"
                                                        onChange={(date) => {
                                                            const year = date?.getFullYear();
                                                            setSelectedYear(year);
                                                            field.onChange(date);
                                                        }}
                                                        className="form-control"
                                                        popperPlacement="top-end"
                                                    />
                                                )}
                                                rules={{
                                                    required: 'Year is required.',
                                                    valueAsDate: true,
                                                }}
                                            />

                                            {errors.year && (
                                                <span className="invalid">
                                                    {errors.year?.message}
                                                </span>
                                            )}
                                        </Col>
                                    </Row>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </fieldset>

            {errors.requisition && <span className="invalid">{errors.requisition?.message}</span>}

            <Tabs
                activeKey={page}
                transition={false}
                id="noanim-tab-example"
                className="mb-3"
                // eslint-disable-next-line radix
                onSelect={(k) => setPage(parseInt(k))}
            >
                {tableDataDisplay()}
            </Tabs>

            <div className="formFooter">
                <Button className="btnCancel" variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button
                    // className="btnInfo me-2 ms-2"
                    className={`btnInfo me-2 ms-2 ${page === 0 && 'd-none'}`}
                    variant="primary"
                    style={{ minWidth: '6rem' }}
                    disabled={page === 0}
                    onClick={() => {
                        setPage((currPage) => currPage - 1);
                    }}
                >
                    Prev
                </Button>
                <Button
                    type="button"
                    className={`btnSuccess ${page === pageLength - 1 && 'd-none'}`}
                    variant="success"
                    style={{ minWidth: '6rem' }}
                    onClick={() => setPage((currPage) => currPage + 1)}
                >
                    Next
                </Button>

                <Button
                    onClick={handleSubmit(formSubmitHandler)}
                    className={`btnSuccess ${page !== pageLength - 1 && 'd-none'}`}
                    type="button"
                    variant="success"
                    style={{ minWidth: '6rem' }}
                    disabled={isSubmitted}
                >
                    {isSubmitted ? `Loading...` : `Submit`}
                </Button>
            </div>
        </Form>
    );
}
